import { render, staticRenderFns } from "./WimexWinterWheat.vue?vue&type=template&id=2a72518c&scoped=true&lang=html&"
import script from "./WimexWinterWheat.vue?vue&type=script&lang=js&"
export * from "./WimexWinterWheat.vue?vue&type=script&lang=js&"
import style0 from "./WimexWinterWheat.vue?vue&type=style&index=0&id=2a72518c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a72518c",
  null
  
)

export default component.exports